import { AgencyConstants } from 'features/Agency/agencyHelper';
import AppConstants from 'general/constants/AppConstants';
import { useMemo } from 'react';

useCharge.propTypes = {};

function useCharge(props) {
  // MARK: ---- PROPERTIES ----
  // doi tuong quan ly tram sac
  const managementObjectOptions = [
    { name: 'Nhà điều hành', value: AppConstants.userRole.admin },
    { name: 'NĐT nhượng quyền', value: AgencyConstants.AgencyRole.INVESTOR },
    { name: 'NĐT liên kết', value: AgencyConstants.AgencyRole.COINVESTOR },
  ];

  return useMemo(() => {
    return {
      managementObjectOptions,
    };
  }, []);
}

export default useCharge;
